<template>
    <div>
        <HeadersWebsite header="จัดการข้อมูลบริษัท" :img_header="header_image" link_back="managewebsite"/>
        <ManageData/>
    </div>
</template>

<script>
    import HeaderImage from "@/assets/process.png"
    import HeadersWebsite from "@/components/admin/manage_website/menu_website/HeadersWebsite.vue";
    import ManageData from "@/components/admin/manage_website/ManageData.vue";
    export default {
        name: "DataPage",
        components: {
            ManageData,
            HeadersWebsite,
        },
        data() {
            return {
                header_image: HeaderImage
            }
        }
    }
</script>

<style scoped>

</style>
